import { gql } from "@apollo/client";

import { EMERSON_PRODUCT_SEARCH_RESULT } from "@emerson/data/splinters/EmersonProductSearchResult.fragment";
import { EMERSON_PRODUCT_SEARCH_RESULT_OPEN } from "@emerson/data/splinters/EmersonProductSearchResultOpen.fragment";
import { PAGE_INFO_FRAGMENT } from "@shared/data/fragments/PageInfoFragment/PageInfoFragment.fragment";

const ProductSearch_Emerson_Query = gql`
  query ProductSearch_Emerson_Query(
    $query: String
    $typeaheadSelectionId: ID
    $initialFilterSelectionId: ID
    $first: Int
    $after: String
    $sort: [ProductSearchSort!]
    $filters: ProductSearchV2FilterObject
    $isUnauthenticated: Boolean = false
  ) {
    viewer {
      productSearchV2(
        query: $query
        typeaheadSelectionId: $typeaheadSelectionId
        initialFilterSelectionId: $initialFilterSelectionId
        first: $first
        after: $after
        sort: $sort
        filters: $filters
      ) {
        nodes {
          ...EmersonProductSearchResult @skip(if: $isUnauthenticated)
          ...EmersonProductSearchResultOpen @include(if: $isUnauthenticated)
        }
        pageInfo {
          ...PageInfoFragment
        }
        totalCount
        pinnedIds
      }
    }
  }
  ${EMERSON_PRODUCT_SEARCH_RESULT}
  ${EMERSON_PRODUCT_SEARCH_RESULT_OPEN}
  ${PAGE_INFO_FRAGMENT}
`;

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { ProductSearch_Emerson_Query };
